// BOOK — clean clinical form with insurance dropdown
export default function Book() {
  return (
    <div className="bg-[#F8FAFB] text-[#0A2E3C]">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1B7A8C]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B7A8C] mb-3">⊕ Section IV / Appointment</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">Book a <span className="italic text-[#1B7A8C]">visit</span>.</h1>
      </section>

      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-12">
        <form className="bg-white border border-[#1B7A8C]/20 shadow-sm p-8 lg:p-12 grid grid-cols-2 gap-x-6 gap-y-6" onSubmit={(e) => e.preventDefault()}>
          <div className="col-span-2 border-b-2 border-[#1B7A8C] pb-3 mb-2 flex items-baseline justify-between">
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B7A8C]">⊕ New Appointment · RX-FORM</span>
            <span className="font-mono text-[10px] text-[#0A2E3C]/45">DRAFT</span>
          </div>
          <Field label="Full name" testId="dent-book-name" />
          <Field label="DOB" type="date" testId="dent-book-dob" />
          <Field label="Email" type="email" testId="dent-book-email" />
          <Field label="Telephone" type="tel" testId="dent-book-tel" />
          <SelectField label="Treatment requested" testId="dent-book-tx" options={['Hygiene · scale & polish', 'New patient consultation', 'Filling · single tooth', 'Crown / Veneer', 'Implant consultation', 'Whitening', 'Emergency']} />
          <SelectField label="Preferred dentist" testId="dent-book-dr" options={['First available', 'Dr. Voss', 'Dr. Chen', 'Dr. Patel']} />
          <SelectField label="Insurance" testId="dent-book-ins" options={['Self-pay', 'Bupa', 'AXA-PPP', 'Vitality', 'WPA', 'Other']} />
          <Field label="Preferred date" type="date" testId="dent-book-date" />
          <div className="col-span-2">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B7A8C] block mb-2">Notes for the practice</label>
            <textarea data-testid="dent-book-notes" rows="4" className="w-full bg-transparent border border-[#1B7A8C]/20 px-3 py-2.5 outline-none focus:border-[#E08672] resize-none text-base" placeholder="Allergies, anxiety, previous work…" />
          </div>
          <button type="button" data-testid="dent-book-submit" className="col-span-2 bg-[#E08672] text-white px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#0A2E3C] transition-colors w-full sm:w-auto sm:justify-self-start">Submit appointment request →</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, type = 'text', testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B7A8C] block mb-2">{label}</label>
      <input type={type} data-testid={testId} className="w-full bg-transparent border border-[#1B7A8C]/20 px-3 py-2.5 outline-none focus:border-[#E08672] text-base" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B7A8C] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border border-[#1B7A8C]/20 px-3 py-2.5 outline-none focus:border-[#E08672] text-base">{options.map(o => <option key={o}>{o}</option>)}</select>
    </div>
  );
}
